// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".store-deletion-modal__container[data-v-fb352806]{padding:30px 40px;min-height:240px;display:flex;flex-direction:column;justify-content:space-between}@media(max-width:599px){.store-deletion-modal__container[data-v-fb352806]{padding:25px 20px}}.store-deletion-modal__text[data-v-fb352806]{line-height:19px;margin-top:10px}", ""]);
// Exports
module.exports = exports;
